import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class ArcGetEligibleArgs extends BaseGetArgs<ArcGetEligibleArgs> {
  @Field({ nullable: true})
  needle?: string

  @Field(t => Int, { nullable: true })
  penNameId?: number

  @Field({ nullable: true})
  penName?: string

  @Field(t => Int, { nullable: true })
  arcTeamId?: number

  @Field(t => Int, { nullable: true })
  arcId?: number

  @Field(t => Boolean, { nullable: true })
  hasComeViaLink?: boolean

  @Field(t => Boolean, { nullable: true })
  activeOnly?: boolean

  @Field(t => Boolean, { nullable: true })
  pastOnly?: boolean

  @Field(t => Boolean, { nullable: true })
  savedOnly?: boolean

  @Field(t => Int, { nullable: true })
  arcType?: number

  @Field(t => Int, { nullable: true })
  sites?: number

  @Field(t => [String], { nullable: true })
  tags?: string[]

  @Field(t => Int, { nullable: true })
  minLength?: number

  @Field(t => Int, { nullable: true })
  maxLength?: number

  @Field(t => [Int], { nullable: true })
  audiences?: number[]

  @Field(t => [Int], { nullable: true })
  languages?: number[]

  @Field(t => Int, { nullable: true })
  canReviewInDays?: number

  @Field(t => Int, { nullable: true })
  categoryId?: number

  @Field(t => [Int], { nullable: true })
  categoryIds?: number[]

  @Field(t => Int, { nullable: true })
  groupByStatus?: number

  @Field(t => Boolean, { nullable: true })
  allUserOwned?: boolean

  @Field(t => Boolean, { nullable: true })
  allowOwnClaim?: boolean

  @Field(t => Int, { nullable: true })
  excludeArcId?: number

  @Field({ nullable: true })
  countOnly?: boolean

  @Field(t => [Int], { nullable: true })
  participationTypes?: number[]

  @Field(t => [Int], { nullable: true })
  releaseDateTypes?: number[]

  @Field(t => [Int], { nullable: true })
  authors?: number[]

  // Deliberately NOT a @Field() - server-internal only, set solely by ArcDigestNotifier
  // for its weekly digest ranking. Never reachable via the public GraphQL schema, so
  // there's no way for a client to request it and no interaction with sortBy/
  // normaliseSortBy/RETIRED_SORTING at all.
  weeklyTraction?: boolean

  // Also server-internal only (no @Field()), set solely by ArcDigestNotifier: restricts
  // the feed to arcs that were NOT yet visible to this reader at this instant (normally
  // the start of the day their previous digest went out), so no arc is offered twice.
  becameVisibleAfter?: Date
}
